import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hierarchy-manager',
  templateUrl: './hierarchy-manager.component.html',
  styleUrls: ['./hierarchy-manager.component.scss']
})
export class HierarchyManagerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
